<template>
  <b-container fluid>
    <b-row>
      <b-col cols="8">
        <b-card class="about-cart">
          <h4 class="about-title">{{ ls_Structure }}</h4>
          <div class="about-content">
            <Diagram v-if="diagramData !== null" :data="diagramData" />
          </div>
        </b-card>
      </b-col>
      <b-col cols="4">
        <sidebar-nav
          :menuTitle="ls_Menu"
          :menuList="leaderMenuList"
          :currentMenu="currentMenu">
        </sidebar-nav>
      </b-col>
    </b-row>
  </b-container>
</template>

<script>
import Diagram from "@/components/Diagram.vue";
import SidebarNavigation from "@/components/navigation/SidebarNavigation.vue";

export default {
  data() {
    return {
      structrue: "",
      diagramData: null
    };
  },

  computed: {
    host() {
      return this.$store.state.host;
    },
    menuList() {
      let list = [];
      if (this.$store.state.navigationList.length > 0) {
        list = this.$store.state.navigationList.filter(
          n => n.url === "/about/us"
        )[0].childList;
      }

      return list;
    },

    currentMenu() {
      return this.menuList.filter(m => this.$route.path.includes(m.url))[0];
    },

    ls_Menu() {
      return this.$store.state.languagePack.ls_Menu;
    },

    ls_Structure() {
      return this.$store.state.languagePack.ls_Structure;
    },

    leaderMenuList() {
      let leaderMenus = [];
      if (this.menuList.length > 0) {
        this.menuList.forEach(function(menu) {
          leaderMenus.push({
            url: menu.url,
            target: menu.target,
            menuTitle: menu.title
          });
        });
      }
      return leaderMenus;
    }
  },

  created() {
    this.getStructure();
  },

  methods: {
    // replaceImage(content) {
    //   return content.replace(
    //     "/uploads/images/",
    //     this.host + "/uploads/images/"
    //   ).replace(". png", ".png").replace(". jpg", ".jpg").replace(". jpeg", ".jpeg");
    // },
    getStructure() {
      let fd = new FormData();
      fd.append("language", this.$route.params.ln);
      this.$http
        .post(this.host + "/api/qazlatyn/getstructurelist", fd)
        .then(result => {
          if (result.status === 200) {
            if (result.body.status === "success") {
              this.diagramData = result.body.data;
            } else {
              // console.log(result.body.message);
            }
          } else {
            // console.log('Err');
          }
        });
    }
  },

  watch: {
    $route(newVal, val) {
      if (val.params.ln !== newVal.params.ln) {
        this.getStructure();
      }
    }
  },

  metaInfo() {
    return {
      title: this.ls_Structure
    };
  },

  components: {
    "sidebar-nav": SidebarNavigation,
    Diagram
  }
};
</script>

<style lang="scss" scoped>
.about-cart {
  border-radius: 0;

  .about-title {
    color: #008496;
    font-size: 1.25rem;
    padding-bottom: 0.5rem;
    border-bottom: 1px solid #008496;
  }

  .about-content {
    padding-top: 1rem;
    font-size: 0.875rem;
    color: #333333;
    font-family: Roboto;

    img {
      width: 100% !important;
    }
  }
}
</style>

<style>
.about-cart .about-content img {
  max-width: 100% !important;
}
</style>
